<form autocomplete="off" [formGroup]="innerForm">
    <div class="float-left smart-tag-form-container container" *ngIf="smartTagModel !== null">
        <ng-template [ngIf]="orderSchema === schemaType.CVDS_40">
            <div class="row">
                <div class="col-md-10 full-width-dropdown">
                    <cv-dropdown
                            [placeholder]="'Is the road that is used to access the subject property publicly or privately maintained?'"
                            [optionText]="'label'"
                            [selectedValue]="dropdownInitialValues['maintainedType']"
                            [options]="smartTagRoadSubjectMaintainedOptions"
                            (valuesChange)="onDropdownValueChange('maintainedType', $event)">
                    </cv-dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10">
                    <div class="custom-control custom-checkbox">
                        <input name="isWellMaintained" formControlName="isWellMaintained"
                               type="checkbox"
                               class="custom-control-input"
                               id="isWellMaintained">
                        <label class="custom-control-label" for="isWellMaintained">Is the road well maintained?</label>
                    </div>
                </div>
            </div>
        </ng-template>
        <div class="row">
            <div class="col-md-10">
                <label>Description:</label>
                <textarea name="description"
                          formControlName="description"
                          (keyup)="smartTagModel.description = $event.currentTarget['value'];"
                          id="report-image-description" name="report-image-description" rows="3"
                          cols="50" [maxLength]="150"></textarea>
            </div>
        </div>
    </div>
</form>
